export function getCookie(name: string) {
  if (typeof window === "undefined") return null;
  const cooks = document.cookie
    .split("; ")
    .find((row) => row.startsWith(name + "="));
  if (!cooks) return null;
  return cooks.split("=")[1];
}

export function setCookie({
  name,
  value,
  expires,
  path,
}: {
  name: string;
  value: string;
  expires?: string;
  path?: string;
}) {
  if (typeof window === "undefined") return;

  const GetDefaultExpiringDate = () => {
    const aYearFromNow = new Date();
    aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
    return aYearFromNow;
  };

  const expDate = expires || GetDefaultExpiringDate();
  const pth = path || "/";

  document.cookie = `${name}=${value};expires=${expDate};path=${pth}`;
}

export function deleteCookie(name: string, path?: string) {
  if (typeof window === "undefined") return;

  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${
    path ? path : "/"
  }`;
}
